import { render, staticRenderFns } from "./InstallationItems.vue?vue&type=template&id=52909ad3&scoped=true"
import script from "./InstallationItems.vue?vue&type=script&lang=js"
export * from "./InstallationItems.vue?vue&type=script&lang=js"
import style0 from "./InstallationItems.vue?vue&type=style&index=0&id=52909ad3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52909ad3",
  null
  
)

export default component.exports